import { useContext, useCallback } from 'react';
import { useAtomValue } from 'jotai';
import { ValidSections, pathnameUrlLanguageAtom } from '../../../../../../../history';
import { articleSearchContext } from './context';

export const useArticleSearchHandlers = () => {
  const handlers = useContext(articleSearchContext);
  return handlers;
};

export const useArticleSearch = () => {
  const [search] = useArticleSearchHandlers();
  return search;
};

export const useMakeArticleSearchPath = () => {
  const language = useAtomValue(pathnameUrlLanguageAtom);
  return useCallback(
    (search: string) => {
      const trimmedSearchTerm = search.trim();
      if (trimmedSearchTerm === '' || trimmedSearchTerm == null) {
        return `/${language}/${ValidSections.NEWS}/search?page=1`;
      }
      return `/${language}/${ValidSections.NEWS}/search?search=${trimmedSearchTerm}&page=1`;
    },
    [
      language,
    ],
  );
};

export const useArticleSearchPath = () => {
  const search = useArticleSearch();
  const makeSearchPath = useMakeArticleSearchPath();
  return makeSearchPath(search);
};

export const useSetArticleSearch = () => {
  const [, setSearch] = useArticleSearchHandlers();
  return setSearch;
};
